"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = exports.ChainCode = void 0;
const types_1 = require("../../types");
const chainCodeBase = (0, types_1.ByteArray)(32);
const chainCodeStatic = {};
const chainCode = Object.assign(chainCodeBase, chainCodeStatic);
exports.ChainCode = chainCode;
// https://regex101.com/r/KwmgAp/1
const pathBase = (0, types_1.BoundedString)(/^((m\/)?(\d+'?\/)*\d+'?)$|^(?![\s\S])/);
const pathStatic = {};
const path = Object.assign(pathBase, pathStatic);
exports.Path = path;
//# sourceMappingURL=types.js.map